import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './BitPayPaymentTerms.scss';

export interface Props {
  className?: string;
}

const BitPayPaymentTerms: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={s['terms']}>
        {t(
          'studio.earnings.bitpay.withdraw.modal.finePrint.exchangeRate.prefix'
        )}{' '}
        <a
          href="https://bitpay.com/exchange-rates/"
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(
            'studio.earnings.bitpay.withdraw.modal.finePrint.exchangeRate.link'
          )}
        </a>
        {t('studio.earnings.bitpay.withdraw.modal.finePrint.terms.prefix')}{' '}
        <a
          href="https://www.deviantart.com/about/policy/service/"
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t(
            'studio.earnings.bitpay.withdraw.modal.finePrint.terms.deviantart'
          )}
        </a>
        {t('studio.earnings.bitpay.withdraw.modal.finePrint.terms.and')}{' '}
        <a
          href="https://bitpay.com/legal/terms-of-use/"
          className="text-link-level-2-secondary"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('studio.earnings.bitpay.withdraw.modal.finePrint.terms.bitpay')}
        </a>
        {t('studio.earnings.bitpay.withdraw.modal.finePrint.terms.suffix')}
      </div>
    </div>
  );
};

BitPayPaymentTerms.displayName = 'BitPayPaymentTerms';

export default BitPayPaymentTerms;
